/** Dedicated Nyafaz Portal — Enterprise franchise control (not salon/brand product consoles). */
export const ENTERPRISE_CONTROL_BASE = "/nyafaz-portal/enterprise-control";
